import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import type { ICellRendererParams } from 'ag-grid-community';
import { formatDate } from '@/utils/formatters';

interface DateCellRendererProps extends ICellRendererParams {
  value: string | null | undefined;
}

export const DateCellRenderer: React.FC<DateCellRendererProps> = ({ value }) => {
  if (!value) {
    return <Typography variant="body2" color="text.secondary">-</Typography>;
  }

  const formattedDate = formatDate(value);
  const relativeTime = getRelativeTime(value);

  return (
    <Tooltip title={formattedDate} arrow>
      <Box>
        <Typography variant="body2">{formattedDate}</Typography>
        {relativeTime && (
          <Typography variant="caption" color="text.secondary">
            {relativeTime}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

function getRelativeTime(dateString: string): string {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    
    return '';
  } catch {
    return '';
  }
}